module.exports = __webpack_public_path__ + "static/img/3_4_1.4acc0d39.jpg";